/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { NodeDependencies } from './dependenciesNode.generated.js';
import { ResultSetDependencies } from './dependenciesResultSet.generated.js';
import { createBlockNode } from '../../factoriesAny.js';
export var BlockNodeDependencies = {
  NodeDependencies,
  ResultSetDependencies,
  createBlockNode
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesBlockNode.generated.js
// module id = 524
// module chunks = 2